import { defineComponent as _defineComponent } from 'vue'
import ClientSignupFlow from "@/modules/Users/SignUp/ClientSignup/AheadClientSignupFlow.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'Signup',
  setup(__props) {


return { __sfc: true,ClientSignupFlow }
}

})